export enum DocumentStatus {
  Rejected = 'Rejected',
}
